<template>
<div class="LoginComponent">

    <div class="loginForm">
        <div class="columns is-mobile is-multiline is-centered">
            <div class=" column is-10 is-offset-1">
                <div class="control">

                    <input class="input" type="text" placeholder="E-Mail" v-model="email"></div>
            </div>

            <div class=" column is-10 is-offset-1">
                <input class="input" type="password" placeholder="Passwort" v-model="password"></div>
            <div class="column is-12">
                <div>
                    <div class="button is-primary is-large" @click="login()">Login</div>
                </div>

            </div>

            <div class="column is-2">
            </div>

        </div>

    </div>

</div>
</div>

</div>
</template>

<script>
export default {
    name: 'Login',
    props: [],
    mounted: function () {},
    data() {
        return {
            msg: 'Welcome to Your Vue.js App',
            data: [],
            email: "",
            password: "",
        }
    },
    methods: {

        login() {
            let postdata = {
                "email": this.email,
                "password": this.password
            }
            this.callApi("/auth/login", "post", postdata).then(function (response) {
                console.log("got response for login: " + JSON.stringify(response.data.access_token))
                localStorage.bearertoken = response.data.access_token
                this.$store.commit('setUsername', response.data.name)
                                this.$store.commit('setUser', response.data)

                if (response.data.is_admin) {
                    console.log("is admin")
                    this.$store.commit('setUserRole', 2)

                } else {
                    console.log("is NOT admin")
                    this.$store.commit('setUserRole', 1)
                }

                this.$router.push({
                    name: 'Projects'
                })

            }.bind(this))
        }
    },
    computed: {},
}
</script>

<style scoped>

</style>
